import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import ContentLayout from "../../../../partials/content/ContentLayout";
import Illustration from "../../../../partials/content/Illustration";
import DialogLayout from "../../../../partials/content/DialogLayout";
import { Badge } from "react-bootstrap";
import {
  getRandomColor,
  createImageFromInitials,
} from "../../../../partials/layout/Avatar";
import { getLeads, deleteLead } from "../../../../services/crm/leadService";
import LeadForm from "./leadForm";
import { Image } from "react-bootstrap";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { whatsappChat } from "../../../../utils/utils";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function Leads({ history }) {
  const { reload } = useGlobalData();
  const [open, setOpen] = useState(false);
  const [leads, setLeads] = useState([]);
  const [lead, setLead] = useState({ ID: 0 });
  const [auth, setAuth] = useState({
    viewAll: false,
    create: false,
    editAll: false,
    deleteAll: false,
  });

  async function getLeadsData() {
    const response = await getLeads();
    const { data, auth } = response.data;
    const { leads } = data;
    setAuth(auth);
    setLeads(leads);
    setOpen(false);
  }

  useEffect(() => {
    getLeadsData();
  }, [reload]);

  const leadDetailColumn = [
    {
      header: "Customer Group",
      field: "customerGroupName",
      type: "string",
    },
    {
      header: "Position",
      field: "position",
      type: "string",
    },
    {
      header: "Website",
      field: "website",
      type: "string",
    },
    {
      header: "Taxpayer Identification Number",
      field: "taxpayerID",
      type: "string",
    },
    {
      header: "Email",
      field: "contactEmail",
      type: "string",
    },
    {
      header: "Industry Type",
      field: "industryTypeName",
      type: "string",
    },
    {
      header: "Business Size",
      field: "businessSizeName",
      type: "string",
    },
    {
      header: "Source",
      field: "sourceName",
      type: "string",
    },
    {
      header: "Priority",
      field: "priorityName",
      type: "string",
    },
    {
      header: "Address",
      field: "address",
      type: "string",
    },
    {
      header: "Province / State",
      field: "province",
      type: "string",
    },
    {
      header: "Country",
      field: "countryName",
      type: "string",
    },
    {
      header: "Postal Code",
      field: "postalCode",
      type: "string",
    },
    {
      header: "Description",
      field: "description",
      type: "string",
    },
    {
      header: "Customer ID",
      field: "customerID",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];
  const actionButtons = [];
  actionButtons.push({
    title: "",
    color: "label-brand",
    icon: "fas fa-backward",
    onClick: () => {
      history.push("/menu");
    },
  });
  if (auth.create) {
    actionButtons.push({
      title: "New Lead",
      color: "primary",
      icon: "fas fa-plus-circle",
      onClick: () => {
        setLead({ ID: 0 });
        setOpen(true);
      },
    });
  }

  return (
    <React.Fragment>
      <PageSubHeader
        title="Lead List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/crm/leads",
            title: "Leads",
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <ContentLayout>
        {leads.length ? (
          <CustomDataTable
            data={leads}
            dataDetailColumns={leadDetailColumn}
            onRefreshData={() => {
              getLeadsData();
            }}
            tableName="lead"
            selectionMode="checkbox"
            columns={[
              {
                selectionMode: "multiple",
              },
              {
                header: "Lead ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Lead Name",
                field: "leadName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.leadName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Contact Name",
                field: "contactName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.contactName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Phone Number",
                field: "contactPhone",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.contactPhone}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "City",
                field: "city",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.city} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Lead Status",
                field: "leadStatusDesc",
                body: (rowData) => {
                  if (rowData.leadStatus === 1) {
                    return (
                      <Badge variant="primary">{rowData.leadStatusDesc}</Badge>
                    );
                  } else if (rowData.leadStatus === 2) {
                    return (
                      <Badge variant="success">{rowData.leadStatusDesc}</Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.leadStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Assigned To",
                field: "assignedUserName",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.assignedUserID !== 0 ? (
                      <React.Fragment>
                        {rowData.assignedUser.userImage ? (
                          <React.Fragment>
                            <div className="kt-widget4">
                              <div className="kt-widget4__item ">
                                <div className="kt-widget4__pic kt-widget4__pic--pic ">
                                  <Image
                                    src={
                                      rowData.assignedUser.userImage.length ===
                                      0
                                        ? createImageFromInitials(
                                            150,
                                            rowData.assignedUser.fullName,
                                            getRandomColor()
                                          )
                                        : rowData.assignedUser.userImage[0]
                                            .imagePath
                                    }
                                    roundedCircle
                                    alt="Avatar"
                                    style={{
                                      width: 32,
                                      height: 32,
                                    }}
                                  />
                                </div>
                                <div className="kt-widget4__info ">
                                  <ResponsiveEllipsis
                                    text={rowData.assignedUserName}
                                    maxLine="1"
                                  />
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        ) : null}
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.contactPhone !== "" ? (
                      <BootstrapTooltip title="Whatsapp Chat Lead">
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            whatsappChat(
                              rowData.contactPhone,
                              `Hi ${rowData.contactName}`
                            );
                          }}
                          className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                        >
                          <i className="flaticon-whatsapp"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                    {rowData.edit && rowData.leadStatus === 1 ? (
                      <BootstrapTooltip title="Edit Lead">
                        <button
                          type="button"
                          onClick={(event) => {
                            setLead(rowData);
                            setOpen(true);
                          }}
                          className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                    {rowData.view ? (
                      <BootstrapTooltip title="Lead Detail">
                        <button
                          type="button"
                          onClick={() => {
                            history.push("/crm/lead-detail/" + rowData.ID);
                          }}
                          className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-list-alt"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                    {rowData.delete && rowData.leadStatus === 1 ? (
                      <BootstrapTooltip title="Delete Lead">
                        <button
                          type="button"
                          onClick={(event) => {
                            handleDeleteLead(rowData.ID);
                          }}
                          className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        ) : (
          <Illustration
            imageSource="INVIFO CRM.png"
            description="Hooray! You're ready to have your first Lead!"
            guidance="Hint: manage your potential customers to grow your market"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
      <DialogLayout
        open={open}
        title="Lead Form"
        onCloseDialog={() => {
          setOpen(false);
        }}
        maxWIdth="md"
      >
        <LeadForm
          lead={lead}
          onCloseDialog={() => {
            setOpen(false);
          }}
          onConfirmSave={() => {
            getLeadsData();
            setOpen(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function handleDeleteLead(leadID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Lead ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteLead(leadID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getLeadsData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
}

export default Leads;
